import React, { useCallback, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useParams } from 'react-router-dom'
import ModalCEPACreateForm from './ModalCEPACreateForm'
import ModalCEPATable from './ModalCEPATable'
import { ProductAddonsTableAndSearchDataState } from './types'
import { ModalBig } from '../../../../../../baseComponents/Modal'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { GroupVatPayload } from '../../../../../../utils/reducers/globals/groupVats'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

type ModalCEProductAddonProps = CreateProductAddonLogicProps & ModalEditComponentProps  &{
    url: string
    title: string
 }

const ModalCEProductAddon: React.FC<ModalCEProductAddonProps & ReduxCreateProductAddon> = ({ title, url, urlGetData, userPermissions, allRowData, groupVats, ...rest }) => {
    const { data, setData, id } = useCreateProductAddonLogic({ urlGetData })
    return (
        <ModalBig opened={true} setOpened={rest.setOpened} className='flex flex-col '>
            <div className='flex flex-col flex-auto h-1 modal_negative_margin'>
                <div className='flex-auto overflow-auto'>
                    <ModalCEPACreateForm groupVats={groupVats} setData={setData} title={title} />
                    <ModalCEPATable id={id || ''} data={data} setData={setData} getData={rest.basicData?.getData} url={url} {...rest} />
                </div>
            </div>
        </ModalBig>
    )
}

interface CreateProductAddonLogicProps {
    urlGetData: string
}

const useCreateProductAddonLogic = ({ urlGetData }: CreateProductAddonLogicProps) => {
    const params = useParams<{ id: string }>()
    const id = params.id
    const [data, setData] = useState<ProductAddonsTableAndSearchDataState>(null)

    const getData = useCallback(async () => {
        const products = await twinFetchPostJSON(urlGetData, {
            where: { 'ProductId': id }, attributes: ['ProductAddonId']
        })
        const parsed: number[] = []
        for (const key in products) {
            const id = products[key]['ProductAddonId']
            parsed.push(id)
        }
        setData((old) => {
            return {
                ids: parsed,
                data: []
            }
        })
    }, [setData, id, urlGetData])

    useEffect(() => {
        getData()
    }, [getData])

    return { data, setData, id }
}

interface ModalCEProductAddonBuyProps extends ModalEditComponentProps {}

export const ModalCEProductAddonBuy: React.FC<ModalCEProductAddonBuyProps> = ({...rest}) => {
    const {t} = useTwinTranslation()
    return (<ModalCEProductAddonConnect title={t('addProductAddonBuy', 'Añadir complemento de compra')} url='/api/app/product/productAddonBuy/assignProductAddonBuy' urlGetData='/api/app/product/productAddonBuy/getAllProductAddonsBuy' {...rest} />)
}

interface ModalCEProductAddonSellProps extends ModalEditComponentProps {}

export const ModalCEProductAddonSell: React.FC<ModalCEProductAddonSellProps> = ({...rest}) => {
    const { t } = useTwinTranslation()
    return (<ModalCEProductAddonConnect title={t('addProductAddonSell', 'Añadir complemento de venta')} url='/api/app/product/productAddon/assignProductAddon' urlGetData='/api/app/product/productAddon/getAllProductAddons' {...rest} />)
}


const createProductAddonDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

const mapCreateProductAddonConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const createProductAddonConnect = connect(mapCreateProductAddonConnector, createProductAddonDispatch)
export type ReduxCreateProductAddon = ConnectedProps<typeof createProductAddonConnect>

const createProductAddonConnectLoading = withLoading(ModalCEProductAddon, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])
const ModalCEProductAddonConnect = createProductAddonConnect(createProductAddonConnectLoading)